/* === Helpers image responsive KAZE : dimensionne les URLs Shopify a la taille reelle
   d'affichage (evite de telecharger du 1400px sur mobile) + garantit que preload,
   swipe-ghost et affichage utilisent la MEME URL -> cache partage, zero re-telechargement. */
(function () {
  window.__kzSized = function (u, w) {
    if (!u) return u;
    u = u.replace(/[?&]width=\d+/gi, function (m) { return m.charAt(0); });
    u = u.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  window.__kzTargetW = function (el) {
    var pw = el && el.getBoundingClientRect ? el.getBoundingClientRect().width : 0;
    if (!pw) pw = window.innerWidth || 800;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.ceil(pw * dpr / 100) * 100;
    if (w < 300) w = 300;
    if (w > 1600) w = 1600;
    return w;
  };
})();

(function () {
  // --- i18n + routes localisées (KZ_PDP_I18N injecté côté liquid) ---
  var I = window.KZ_PDP_I18N || {};
  function t(k, d) { return I[k] || d; }
  function kzRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  // FIX C : listeners window/document attaches par init() -> retire les anciens avant reattache
  // pour eviter l'accumulation au shopify:section:load (noeuds detaches).
  var kzWinScroll = null, kzWinResize = null;
  // --- Cross-sell helpers : panier KAZE = lien .kzh__cart + badge [data-kzh-count] ---
  function kzCartEl() { return document.querySelector('.kzh__cart'); }
  function kzUpdateCount(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    document.querySelectorAll('[data-kzh-count]').forEach(function (el) { el.textContent = String(count); });
  }
  function kzBumpCart() {
    var c = kzCartEl();
    if (!c || !c.animate) return;
    c.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }],
      { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)' }
    );
  }
  // Animation "tir au panier" : une boule (image produit) suit une courbe de Bézier
  // du bouton jusqu'à l'icône panier, rétrécit et s'estompe à l'arrivée.
  function kzFlyToCart(srcEl, imgUrl, onDone) {
    var dest = kzCartEl();
    if (!srcEl || !dest) { return; }
    var s = srcEl.getBoundingClientRect();
    var d = dest.getBoundingClientRect();
    if (!s.width || !d.width) return;
    var startX = s.left + s.width / 2, startY = s.top + s.height / 2;
    var endX = d.left + d.width / 2, endY = d.top + d.height / 2;
    var ctrlX = (startX + endX) / 2;
    var lift = Math.max(130, Math.abs(endX - startX) * 0.4);
    var ctrlY = Math.min(startY, endY) - lift;
    var ball = document.createElement('div');
    ball.style.cssText = 'position:fixed;left:0;top:0;width:48px;height:48px;border-radius:50%;z-index:99999;pointer-events:none;background:#16161a center/cover no-repeat;box-shadow:0 8px 22px rgba(0,0,0,.3);will-change:transform,opacity;';
    if (imgUrl) ball.style.backgroundImage = 'url(' + imgUrl + ')';
    document.body.appendChild(ball);
    var dur = 760, t0 = null;
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = ease(p);
      var mt = 1 - e;
      var x = mt * mt * startX + 2 * mt * e * ctrlX + e * e * endX;
      var y = mt * mt * startY + 2 * mt * e * ctrlY + e * e * endY;
      var scale = 1 - 0.62 * e;
      ball.style.transform = 'translate(' + (x - 24) + 'px,' + (y - 24) + 'px) scale(' + scale + ')';
      ball.style.opacity = p > 0.82 ? String(1 - (p - 0.82) / 0.18) : '1';
      if (p < 1) { requestAnimationFrame(frame); }
      else { ball.remove(); kzBumpCart(); if (typeof onDone === 'function') onDone(); }
    }
    requestAnimationFrame(frame);
  }
  // Expose l'animation "tir au panier" pour le module cross-sell (encoche).
  window.__kzFlyToCart = kzFlyToCart;
  function init(root) {
    if (!root || root.dataset.kzInit) return;
    root.dataset.kzInit = '1';
    // FIX C : retire les listeners window de l'init precedent (evite fuite au section:load)
    if (kzWinScroll) { window.removeEventListener('scroll', kzWinScroll); kzWinScroll = null; }
    if (kzWinResize) { window.removeEventListener('resize', kzWinResize); kzWinResize = null; }
    var xwrap = root.querySelector('.kz-block--xwrap');
    if (xwrap) {
      var xsc = xwrap.querySelector('[data-kz-xscroll]');
      var xdots = xwrap.querySelectorAll('[data-kz-xdot]');
      if (xsc && xdots.length > 1) {
        var xstep = function () { var c = xsc.querySelector('.kz-xrow'); return c ? c.getBoundingClientRect().width + 12 : xsc.clientWidth; };
        var xupd = function () { var i = Math.round(xsc.scrollLeft / xstep()); i = Math.max(0, Math.min(xdots.length - 1, i)); xdots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); }); };
        xsc.addEventListener('scroll', function () { requestAnimationFrame(xupd); }, { passive: true });
        xdots.forEach(function (d, n) { d.addEventListener('click', function () { xsc.scrollTo({ left: n * xstep(), behavior: 'smooth' }); }); });
        xupd();
      }
    }
    // Cross-sell: ajout direct au panier SANS quitter la page ni ouvrir le tiroir,
    // avec animation "tir au panier" + compteur du header qui s'incrémente.
    root.querySelectorAll('.kz-xrow a.kz-add[href]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (link.dataset.kzBusy === '1') return;
        link.dataset.kzBusy = '1';
        var label = link.textContent;
        link.textContent = t('adding', 'Ajout…');
        var row = link.closest('.kz-xrow');
        var thumbImg = row ? row.querySelector('.kz-xrow__thumb img') : null;
        var imgUrl = thumbImg ? (thumbImg.currentSrc || thumbImg.src) : null;
        kzFlyToCart(thumbImg || link, imgUrl);
        var href = link.getAttribute('href');
        var jsonUrl = href.split('?')[0].replace(/\/$/, '') + '.js';
        fetch(jsonUrl, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var variants = p.variants || [];
            var v = variants.filter(function (x) { return x.available; })[0] || variants[0];
            if (!v) throw new Error('no variant');
            if (window.KazeCart) return window.KazeCart.addItem(v.id, false);
            return fetch(kzRoot() + 'cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
            }).then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(kzRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
              .then(function (r) { return r.json(); })
              .then(function (cart) { kzUpdateCount(cart.item_count); });
          })
          .then(function () {
            link.dataset.kzBusy = '0';
            link.textContent = t('added', 'Ajouté ✓');
            setTimeout(function () { link.textContent = label; }, 1600);
          })
          .catch(function () { link.dataset.kzBusy = '0'; link.textContent = label; window.location.href = href; });
      });
    });
    var idInput = root.querySelector('[data-kz-id]');
    var finishEls = root.querySelectorAll('[data-kz-finish]');
    var ctaPrice = root.querySelector('[data-kz-cta-price]');
    var ctaWas = root.querySelector('[data-kz-cta-was]');
    var ctaBtn = root.querySelector('[data-kz-cta]');
    var ctaLabel = root.querySelector('[data-kz-cta-label]');
    var ctaHint = root.querySelector('[data-kz-cta-hint]');
    var ctaPriceWrap = root.querySelector('[data-kz-cta-pricewrap]');
    var saleBadge = root.querySelector('[data-kz-sale-badge]');
    var promoNote = root.querySelector('[data-kz-promo-note]');
    var priceEls = root.querySelectorAll('[data-kz-price], [data-kz-sprice], [data-kz-scur]');
    var sCompare = root.querySelector('[data-kz-scompare]');
    var discEl = root.querySelector('[data-kz-disc]');
    var mainImg = root.querySelector('.kz-panel__img');
    var msrc = root.querySelector('[data-kz-msrc]');
    var sImg = root.querySelector('[data-kz-simg]');
    var heroVid = root.querySelector('[data-kz-vid]');
    var thumbs = root.querySelectorAll('.kz-thumb[data-kz-alt]');
    function kzFilterThumbs(title) {
      var t = (title || '').toLowerCase();
      thumbs.forEach(function (th) {
        var show = th.dataset.kzShared === '1' || (t && (th.dataset.kzAlt || '').indexOf(t) !== -1);
        th.classList.toggle('kz-thumb--hidden', !show);
      });
    }
    // --- Points de pagination sous les miniatures (nombre = miniatures visibles) ---
    var thumbsWrap = root.querySelector('.kz-thumbs');
    var tdots = null;
    function kzVisThumbs() {
      if (!thumbsWrap) return [];
      return Array.prototype.filter.call(thumbsWrap.querySelectorAll('.kz-thumb[data-kz-alt]'), function (t) { return !t.classList.contains('kz-thumb--hidden'); });
    }
    function kzActiveDot(i) {
      if (!tdots) { kzUpdArrows(); return; }
      var ds = tdots.querySelectorAll('.kz-tdot');
      for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('is-active', k === i);
      kzUpdArrows();
    }
    function kzBuildDots() {
      if (!thumbsWrap) return;
      if (!tdots) { tdots = document.createElement('div'); tdots.className = 'kz-tdots'; thumbsWrap.parentNode.insertBefore(tdots, thumbsWrap.nextSibling); }
      var th = kzVisThumbs();
      if (th.length < 2) { tdots.innerHTML = ''; return; }
      var html = '';
      for (var i = 0; i < th.length; i++) html += '<button type="button" class="kz-tdot' + (i === 0 ? ' is-active' : '') + '" aria-label="Image ' + (i + 1) + '"></button>';
      tdots.innerHTML = html;
      var ds = tdots.querySelectorAll('.kz-tdot');
      for (var j = 0; j < ds.length; j++) {
        (function (n) { ds[n].addEventListener('click', function () { th[n].click(); kzActiveDot(n); }); })(j);
      }
    }
    // --- Fleches de navigation galerie (desktop) : reutilisent miniatures + dots ---
    var gprev = root.querySelector('[data-kz-gprev]'), gnext = root.querySelector('[data-kz-gnext]');
    function kzCurIdx(){ if(!tdots) return 0; var ds = tdots.querySelectorAll('.kz-tdot'); for(var i=0;i<ds.length;i++){ if(ds[i].classList.contains('is-active')) return i; } return 0; }
    function kzUpdArrows(){ var n = kzVisThumbs().length, i = kzCurIdx(); if(gprev) gprev.hidden = (n<2 || i<=0); if(gnext) gnext.hidden = (n<2 || i>=n-1); }
    function kzGo(d){ var th = kzVisThumbs(); if(th.length<2) return; var i = kzCurIdx()+d; if(i<0)i=0; if(i>th.length-1)i=th.length-1; th[i].click(); kzActiveDot(i); kzUpdArrows(); }
    if(gprev) gprev.addEventListener('click', function(){ kzGo(-1); });
    if(gnext) gnext.addEventListener('click', function(){ kzGo(1); });
    if (thumbsWrap) {
      thumbsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('.kz-thumb[data-kz-alt]'); if (!t) return;
        var th = kzVisThumbs(); var idx = th.indexOf(t); if (idx > -1) kzActiveDot(idx);
      });
    }
    var kzDotsRTO;
    // FIX C : sera attache via le handler resize module unique (voir plus bas)
    var kzDotsResize = function () { clearTimeout(kzDotsRTO); kzDotsRTO = setTimeout(kzBuildDots, 200); };
    root.querySelectorAll('input[name=kz-variant]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (idInput) idInput.value = r.value;
        if (r.dataset.title) finishEls.forEach(function (el) { el.textContent = r.dataset.title; });
        var kzAvail = r.dataset.available !== '0';
        var kzNow = (!kzAvail && r.dataset.compare) ? r.dataset.compare : r.dataset.price;
        if (ctaPrice && r.dataset.price) ctaPrice.textContent = r.dataset.price;
        if (kzNow) priceEls.forEach(function (el) { el.textContent = kzNow; });
        if (sCompare) { if (r.dataset.compare && kzAvail) { sCompare.textContent = r.dataset.compare; sCompare.hidden = false; } else { sCompare.hidden = true; } }
        if (ctaWas) { if (r.dataset.compare) { ctaWas.textContent = r.dataset.compare; ctaWas.hidden = false; } else { ctaWas.hidden = true; } }
        if (ctaBtn) {
          ctaBtn.type = kzAvail ? 'submit' : 'button';
          ctaBtn.classList.toggle('is-soldout', !kzAvail);
          ctaBtn.dataset.variant = r.value;
          ctaBtn.dataset.variantName = r.dataset.title || '';
          if (ctaLabel) ctaLabel.textContent = kzAvail ? (ctaBtn.dataset.labelAdd || '') : (ctaBtn.dataset.labelSoldout || '');
          if (ctaHint) ctaHint.hidden = kzAvail;
        }
        if (ctaPriceWrap) ctaPriceWrap.hidden = !kzAvail;
        if (saleBadge) saleBadge.hidden = !r.dataset.compare || !kzAvail;
        if (discEl) { if (r.dataset.disc) discEl.textContent = r.dataset.disc; discEl.hidden = !r.dataset.compare || !kzAvail; }
        if (promoNote) promoNote.hidden = !r.dataset.compare;
        if (mainImg && r.dataset.image) kzSetMain(r.dataset.image);
        if (msrc && r.dataset.imageM) msrc.srcset = r.dataset.imageM;
        if (sImg && r.dataset.image) sImg.src = r.dataset.image;
        if (heroVid) { heroVid.pause(); heroVid.hidden = true; heroVid.removeAttribute('src'); }
        kzFilterThumbs(r.dataset.title);
        kzBuildDots();
        kzUpdArrows();
        setTimeout(kzPreload, 300);
        root.querySelectorAll('.kz-tile').forEach(function (el) { el.classList.remove('is-active'); });
        var label = r.closest('.kz-tile');
        if (label) label.classList.add('is-active');
      });
    });
    var kzChecked = root.querySelector('input[name=kz-variant]:checked');
    if (kzChecked) kzFilterThumbs(kzChecked.dataset.title);
    if (heroVid) heroVid.addEventListener('click', function () {
      heroVid.pause(); heroVid.hidden = true; heroVid.removeAttribute('src');
    });
    root.querySelectorAll('[data-kz-vthumb]').forEach(function (vt) {
      vt.addEventListener('click', function () {
        var u = vt.dataset.video; if (!u || !heroVid) return;
        var vimg = vt.querySelector('img');
        var poster = vt.dataset.poster || (vimg && (vimg.currentSrc || vimg.src)) || '';
        if (poster) {
          heroVid.setAttribute('poster', poster);
          if (mainImg) kzSetMain(poster);
          if (msrc) msrc.srcset = poster;
        }
        heroVid.src = u; heroVid.muted = true; heroVid.hidden = false;
        var pv = heroVid.play(); if (pv && pv.catch) pv.catch(function () {});
      });
    });
    var stickyAdd = root.querySelector('[data-kz-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var f = root.querySelector('.kz-form');
        if (!f) return;
        if (f.requestSubmit) { f.requestSubmit(); } else { f.submit(); }
      });
    }
    var stickyBar = root.querySelector('[data-kz-stickybar]');
    var kzStickyScroll = null, kzStickyResize = null;
    if (stickyBar) {
      var wrapper = root.closest('.shopify-section') || root.parentElement;
      var trigger = wrapper ? wrapper.nextElementSibling : null;
      // FIX B (bannière cookies) : ne pas afficher la barre sticky tant que la bannière
      // cookies KAZE (#kz-cc) est visible (classe is-visible). Fallback SUR : si la
      // bannière n'existe pas / n'est pas visible, on ne bloque rien.
      var kzCookieBanner = document.getElementById('kz-cc');
      var kzCookieVisible = function () {
        return !!(kzCookieBanner && kzCookieBanner.classList.contains('is-visible'));
      };
      // FIX A : ne recalcule le seuil (scrollHeight/getBoundingClientRect) qu'au resize,
      // pas a chaque scroll (evite le layout thrashing mobile).
      var kzRevealThreshold = 0;
      var recomputeThreshold = function () {
        var scrollable = (document.documentElement.scrollHeight - window.innerHeight) || 1;
        var triggerY;
        if (trigger) { triggerY = trigger.getBoundingClientRect().top + window.scrollY - window.innerHeight; }
        else { triggerY = window.innerHeight; }
        if (triggerY < 0) triggerY = 0;
        var pct = Math.min((triggerY / scrollable) * 2, 0.95);
        kzRevealThreshold = pct * scrollable;
      };
      // reveal() ne fait plus que lire scrollY + comparer au seuil pre-calcule + ecrire la classe.
      // FIX B : si la bannière cookies est visible, on masque la barre et on sort tot.
      var reveal = function () {
        if (kzCookieVisible()) { stickyBar.classList.remove('is-revealed'); return; }
        stickyBar.classList.toggle('is-revealed', window.scrollY >= kzRevealThreshold);
      };
      recomputeThreshold();
      reveal();
      // FIX B : quand la bannière cookies est traitée (classe is-visible retiree),
      // on re-declenche reveal() pour que la barre puisse apparaitre sans nouveau scroll.
      if (kzCookieBanner && window.MutationObserver) {
        var kzCookieObs = new MutationObserver(function () { reveal(); });
        kzCookieObs.observe(kzCookieBanner, { attributes: true, attributeFilter: ['class'] });
      }
      // FIX A : throttle rAF sur scroll (une seule ecriture de classe par frame).
      var ticking = false;
      kzStickyScroll = function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () { reveal(); ticking = false; });
        }
      };
      kzStickyResize = function () { recomputeThreshold(); reveal(); };
    }
    // FIX A + FIX C : handlers window uniques au niveau module, remplaces a chaque init
    // (les anciens ont ete retires en tete d'init).
    kzWinScroll = function () { if (kzStickyScroll) kzStickyScroll(); };
    kzWinResize = function () { kzDotsResize(); if (kzStickyResize) kzStickyResize(); };
    window.addEventListener('scroll', kzWinScroll, { passive: true });
    window.addEventListener('resize', kzWinResize);
    root.querySelectorAll('[data-kz-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { if (mainImg && t.dataset.full) kzSetMain(t.dataset.full); if (heroVid) { heroVid.pause(); heroVid.hidden = true; heroVid.removeAttribute('src'); } setTimeout(kzPreload, 60); });
    });
    kzBuildDots();
    kzUpdArrows();
    // Dimensionne les images a la taille reelle du panneau (mobile = bien plus leger) et
    // garantit une URL identique pour l'affichage, le preload et le swipe -> cache partage.
    function kzPanelW() { var p = root.querySelector('.kz-panel'); return window.__kzTargetW(p || (mainImg && mainImg.parentNode) || null); }
    function kzSized(u) { return window.__kzSized ? window.__kzSized(u, kzPanelW()) : u; }
    function kzSetMain(u) { if (!mainImg || !u) return; mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = kzSized(u); }
    // Precharge l'image precedente ET suivante (avec wrap) a la MEME taille que l'affichage.
    function kzPreload() {
      var th = kzVisThumbs();
      if (th.length < 2) return;
      var cur = 0;
      if (tdots) {
        var ds = tdots.querySelectorAll('.kz-tdot');
        for (var k = 0; k < ds.length; k++) { if (ds[k].classList.contains('is-active')) { cur = k; break; } }
      }
      var nxt = cur + 1 >= th.length ? 0 : cur + 1;
      var prv = cur - 1 < 0 ? th.length - 1 : cur - 1;
      [prv, nxt].forEach(function (n) {
        var t = th[n];
        if (!t) return;
        var u = t.dataset.full || t.dataset.poster;
        if (u) { var im = new Image(); im.src = kzSized(u); }
      });
    }
    setTimeout(kzPreload, 500);
    var overlay = root.querySelector('[data-kz-lb-overlay]');
    var lbImg = root.querySelector('[data-kz-lb-img]');
    var lbLink = root.querySelector('[data-kz-lb-link]');
    root.querySelectorAll('[data-kz-lb]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!overlay) return;
        if (lbImg) {
          if (b.dataset.img) { lbImg.src = b.dataset.img; lbImg.style.display = ''; }
          else { lbImg.removeAttribute('src'); lbImg.style.display = 'none'; }
        }
        if (lbLink) {
          if (b.dataset.url) { lbLink.href = b.dataset.url; lbLink.style.display = ''; }
          else { lbLink.style.display = 'none'; }
        }
        overlay.classList.add('is-open');
      });
    });
    if (lbLink) lbLink.addEventListener('click', function (e) { e.stopPropagation(); });
    if (overlay) overlay.addEventListener('click', function () { overlay.classList.remove('is-open'); });

    var card = root.querySelector('.kz-card');
    var tabs = root.querySelectorAll('[data-kz-tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var isBundle = t.dataset.kzTab === 'bundle';
        if (card) card.classList.toggle('is-bundle', isBundle);
        root.dataset.kzBundle = isBundle ? '1' : '0';
      });
    });
    // CTA principal + pack + barre sticky : animation "tir au panier" PUIS ouverture du tiroir KAZE.
    var form = root.querySelector('.kz-form');
    var bundleEl = root.querySelector('[data-kz-bundle-id]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var wid = idInput ? idInput.value : null;
        if (!wid) return;
        if (ctaBtn && ctaBtn.classList.contains('is-soldout')) return;
        var items = [{ id: wid, quantity: 1 }];
        if (root.dataset.kzBundle === '1' && bundleEl && bundleEl.dataset.kzBundleId) {
          items.push({ id: bundleEl.dataset.kzBundleId, quantity: 1 });
        }
        if (window.KazeCart) {
          // Element source du tir : le bouton reellement cliqué (submitter), sinon
          // le bouton de la barre sticky si elle est visible, sinon le CTA du form.
          var srcBtn = e.submitter || (stickyBar && stickyBar.classList.contains('is-revealed') ? stickyBar.querySelector('[data-kz-sticky-add]') : null) || form.querySelector('.kz-cta');
          var imgUrl = mainImg ? (mainImg.currentSrc || mainImg.src) : null;
          // Animation D'ABORD ; le tiroir s'ouvre a la FIN de l'anim (callback).
          kzFlyToCart(srcBtn, imgUrl, function () { if (window.KazeCart) window.KazeCart.open(); });
          // Ajout SILENCIEUX en arriere-plan (pas d'ouverture immediate).
          window.KazeCart.addItems(items, false).catch(function () { window.location.href = kzRoot() + 'cart'; });
        } else {
          fetch(kzRoot() + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function () { window.location.href = kzRoot() + 'cart'; }).catch(function () { form.submit(); });
        }
      });
    }
    if (ctaBtn) ctaBtn.addEventListener('click', function (e) {
      if (!ctaBtn.classList.contains('is-soldout')) return;
      e.preventDefault();
      if (window.kzBIS) window.kzBIS.open(ctaBtn.dataset.variant, ctaBtn.dataset.variantName);
    });
  }
  function boot() { document.querySelectorAll('[data-kz-pdp]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

/* === Swipe premium image principale (mobile, suit le doigt) - KAZE v2 (gere la video) === */
(function () {
  var THRESH = 45, LOCK = 8, DUR = 260;
  function vis(wrap) {
    return Array.prototype.filter.call(
      wrap.querySelectorAll('.kz-thumb[data-kz-alt]'),
      function (t) { return !t.classList.contains('kz-thumb--hidden'); }
    );
  }
  function curIdx(root) {
    var dots = root.querySelectorAll('.kz-tdots .kz-tdot');
    for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('is-active')) return i;
    return 0;
  }
  function thumbUrl(t) {
    if (t.dataset.poster) return t.dataset.poster;
    if (t.dataset.full) return t.dataset.full;
    var im = t.querySelector('img');
    return im ? (im.currentSrc || im.src) : null;
  }
  function mkGhost(url) {
    var g;
    if (url) {
      g = document.createElement('img');
      g.src = url;
      g.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:3;pointer-events:none;will-change:transform;';
    } else {
      g = document.createElement('div');
      g.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;background:var(--kz-panel,#f1f1f2);z-index:3;pointer-events:none;will-change:transform;';
    }
    g.className = 'kz-swipe-ghost';
    return g;
  }
  function bind(root) {
    if (root.dataset.kzSwipe) return;
    root.dataset.kzSwipe = '1';
    var panel = root.querySelector('.kz-panel');
    var wrap = root.querySelector('.kz-thumbs');
    var img = root.querySelector('.kz-panel__img');
    var vid = root.querySelector('[data-kz-vid]');
    if (!panel || !wrap || !img) return;
    var stageEls = vid ? [img, vid] : [img];
    function setT(x) { stageEls.forEach(function (el) { el.style.transform = 'translateX(' + x + 'px)'; }); }
    function setTr(tr) { stageEls.forEach(function (el) { el.style.transition = tr; }); }
    function resetStage() { stageEls.forEach(function (el) { el.style.transition = ''; el.style.transform = ''; el.style.willChange = ''; }); }
    function sz(u) { return (u && window.__kzSized && window.__kzTargetW) ? window.__kzSized(u, window.__kzTargetW(panel)) : u; }
    var sx = 0, sy = 0, w = 0, th = [], i = 0;
    var decided = false, horiz = false, active = false, busy = false;
    var gPrev = null, gNext = null;
    function clearGhosts() {
      if (gPrev) { gPrev.remove(); gPrev = null; }
      if (gNext) { gNext.remove(); gNext = null; }
    }
    // Ne retire le(s) fantome(s) qu'une fois l'image finale reellement chargee/decodee,
    // sinon on revele une mainImg pas encore prete (flash retour a l'ancienne image).
    function revealWhenReady() {
      var done = false;
      var finish = function () {
        if (done) return; done = true;
        clearGhosts();
        void img.offsetWidth;
        resetStage();
        busy = false;
      };
      if (img.complete) {
        finish();
      } else {
        img.addEventListener('load', finish, { once: true });
        img.addEventListener('error', finish, { once: true });
        setTimeout(finish, 400);
      }
    }
    panel.addEventListener('touchstart', function (e) {
      if (busy || e.touches.length > 1) { active = false; return; }
      th = vis(wrap);
      if (th.length < 2) { active = false; return; }
      var t = e.touches[0];
      sx = t.clientX; sy = t.clientY;
      w = panel.getBoundingClientRect().width || 1;
      i = curIdx(root);
      decided = false; horiz = false; active = true;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!active) return;
      var t = e.touches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (!decided) {
        if (Math.abs(dx) < LOCK && Math.abs(dy) < LOCK) return;
        decided = true;
        horiz = Math.abs(dx) > Math.abs(dy);
        if (horiz) {
          stageEls.forEach(function (el) { el.style.willChange = 'transform'; });
          var pu = i > 0 ? sz(thumbUrl(th[i - 1])) : null;
          var nu = sz(i < th.length - 1 ? thumbUrl(th[i + 1]) : thumbUrl(th[0]));
          if (i > 0) { gPrev = mkGhost(pu); panel.appendChild(gPrev); }
          gNext = mkGhost(nu); panel.appendChild(gNext);
        }
      }
      if (!horiz) return;
      e.preventDefault();
      var d = dx;
      if (dx > 0 && i === 0) d = dx * 0.32;
      setT(d);
      if (gPrev) gPrev.style.transform = 'translateX(' + (d - w) + 'px)';
      if (gNext) gNext.style.transform = 'translateX(' + (d + w) + 'px)';
    }, { passive: false });
    panel.addEventListener('touchend', function (e) {
      if (!active) return; active = false;
      if (!horiz) return;
      var dx = e.changedTouches[0].clientX - sx;
      var go = null;
      var wrapped = false;
      if (dx <= -THRESH) {
        if (i < th.length - 1) { go = i + 1; }
        else { go = 0; wrapped = true; }
      }
      else if (dx >= THRESH && i > 0) go = i - 1;
      var ease = 'transform ' + DUR + 'ms cubic-bezier(.22,.61,.36,1)';
      setTr(ease);
      if (gPrev) gPrev.style.transition = ease;
      if (gNext) gNext.style.transition = ease;
      busy = true;
      if (go === null) {
        setT(0);
        if (gPrev) gPrev.style.transform = 'translateX(' + (-w) + 'px)';
        if (gNext) gNext.style.transform = 'translateX(' + w + 'px)';
        setTimeout(function () {
          clearGhosts();
          resetStage();
          busy = false;
        }, DUR + 30);
        return;
      }
      var forward = wrapped || (go > i);
      var out = forward ? -w : w;
      var ghost = forward ? gNext : gPrev;
      setT(out);
      if (ghost) ghost.style.transform = 'translateX(0px)';
      setTimeout(function () {
        setTr('none');
        th[go].click();
        setT(0);
        // Le fantome (deja charge) reste visible par-dessus jusqu'a ce que mainImg
        // ait fini de charger la nouvelle image -> plus de flash vers l'ancienne image.
        revealWhenReady();
      }, DUR + 30);
    }, { passive: true });
    panel.addEventListener('touchcancel', function () {
      if (!active) return;
      active = false;
      if (!horiz) return;
      setTr('none');
      setT(0);
      clearGhosts();
      resetStage();
      busy = false;
    }, { passive: true });
  }
  function boot() { document.querySelectorAll('[data-kz-pdp]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* === Cross-sell PDP : encoche (toggle iPhone) -> panneau variantes -> AJOUT AU PANIER ===
   A la selection d'une variante : ajout au panier SANS ouvrir le tiroir + animation "tir
   au panier" + le texte affiche devient le PRIX. Module autonome (ne touche pas galerie/swipe). */
(function () {
  function kzRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function closeAll(exceptPop, exceptInput) {
    document.querySelectorAll('[data-kz-xpop]').forEach(function (p) { if (p !== exceptPop) p.hidden = true; });
    document.querySelectorAll('[data-kz-xtoggle-input]').forEach(function (i) { if (i !== exceptInput) i.checked = false; });
  }
  function init(item) {
    if (item.dataset.kzXinit) return;
    item.dataset.kzXinit = '1';
    var input = item.querySelector('[data-kz-xtoggle-input]');
    var pop = item.querySelector('[data-kz-xpop]');
    var priceEl = item.querySelector('[data-kz-xvar-price]');
    var rowImg = item.querySelector('[data-kz-ximg]');
    function addVariant(vid, srcEl, vimg) {
      if (!vid) return;
      var img = vimg || (rowImg && (rowImg.currentSrc || rowImg.src)) || null;
      if (window.__kzFlyToCart) window.__kzFlyToCart(srcEl, img);
      if (window.KazeCart) { window.KazeCart.addItem(vid, false); return; }
      fetch(kzRoot() + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      }).then(function () { return fetch(kzRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') {
            document.querySelectorAll('[data-kzh-count]').forEach(function (el) { el.textContent = String(cart.item_count); });
          }
        }).catch(function () {});
    }
    if (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          if (pop) {
            closeAll(pop, input);
            pop.hidden = false;
          } else {
            closeAll(null, input);
            addVariant(item.dataset.kzXsingle, input);
            input.checked = false;
          }
        } else {
          if (pop) pop.hidden = true;
        }
      });
    }
    item.querySelectorAll('[data-kz-xopt]').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        var vid = opt.getAttribute('data-vid');
        var vprice = opt.getAttribute('data-vprice') || '';
        var vimg = opt.getAttribute('data-vimg') || '';
        addVariant(vid, opt, vimg);
        if (priceEl && vprice) priceEl.textContent = vprice;
        if (rowImg && vimg) rowImg.src = vimg;
        item.querySelectorAll('[data-kz-xopt]').forEach(function (o) { o.classList.remove('is-sel'); });
        opt.classList.add('is-sel');
        if (pop) pop.hidden = true;
        if (input) input.checked = false;
      });
    });
  }
  function boot() { document.querySelectorAll('[data-kz-xitem]').forEach(init); }
  // Fermeture au clic exterieur + touche Echap (attaches une seule fois).
  if (!window.__kzXpopBound) {
    window.__kzXpopBound = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-kz-xitem]')) return;
      closeAll(null, null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeAll(null, null);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Cross-sell: cliquer l'image de la ligne redirige vers la page produit (le bouton ! garde la lightbox) */
(function(){try{document.addEventListener('click',function(e){var thumb=e.target&&e.target.closest?e.target.closest('.kz-xrow__thumb'):null;if(!thumb)return;var row=thumb.closest('.kz-xrow');if(!row)return;var urlEl=row.querySelector('[data-url]');var u=thumb.getAttribute('data-url')||(urlEl&&urlEl.getAttribute('data-url'));if(u){e.preventDefault();e.stopPropagation();window.location.href=u;}},true);}catch(_){}})();
/* kz-xrow__thumb--navfix */
